import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import Concept from './components/Concept';
import Packages from './components/Packages';
import Experience from './components/Experience';
import Gallery from './components/Gallery';
import { Testimonials, FAQ } from './components/Testimonials';
import LagoonMonthly from './components/LagoonMonthly';
import LagoonCarnet from './components/LagoonCarnet';
import Footer from './components/Footer';
import AdminDashboard from './pages/AdminDashboard';
import BoutiquePage from './pages/BoutiquePage';
import TrackOrderPage from './pages/TrackOrderPage';
import CartMembrePage from './pages/CartMembrePage';
import VerifyMemberPage from './pages/VerifyMemberPage';
import { ReservationProvider } from './context/ReservationContext';
import { CartProvider } from './context/CartContext';

const Home = () => (
  <div className="min-h-screen bg-white">
    <Header />
    <main>
      <Hero />
      <Packages />
      <Experience />
      <Gallery />
      <LagoonMonthly />
      <LagoonCarnet />
      <Testimonials />
      <FAQ />
      <Concept />
    </main>
    <Footer />
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <CartProvider>
          <ReservationProvider>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/boutique" element={<BoutiquePage />} />
              <Route path="/suivi" element={<TrackOrderPage />} />
              <Route path="/suivi/:ref" element={<TrackOrderPage />} />
              <Route path="/carte-membre" element={<CartMembrePage />} />
              <Route path="/verifier-membre/:number" element={<VerifyMemberPage />} />
              <Route path="/admin" element={<AdminDashboard />} />
            </Routes>
          </ReservationProvider>
        </CartProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
